import Error from "../../views/Error";

export default [
  {
    path: "*",
    component: Error,
    name : "error"
  }
];
